/**
 * Shared vocabulary for the two Orca template markers — placeholders and conditions.
 */
/**
 * Used when no resolver is configured, which is every editor except the template builder. Renders the
 * raw ref, as those editors always have.
 */
export function resolveTemplateRefFallback(ref) {
    if (!ref) {
        return { state: 'unconfigured', label: '' };
    }
    return { state: 'linked', label: ref };
}
